import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { map, shareReplay, retry, catchError } from 'rxjs/operators';
import {
  InstagramGalleryService,
  FacebookPage, FacebookPageEdge,
  GraphEdgeResponse
} from 'src/app/services/instagram-gallery.service';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { SanctumService } from 'src/app/services/sanctum.service';
import { RevalidatedHttpService, RevalidatedResource } from 'src/app/core/http-cache/revalidated-http.service';
import {
  InstagramAccount,
  Feed,
  FeedFilters,
  FeedFilterTree,
  FeedIngest,
  ListFeedsPayload,
  User,
  CreateFeedPayload,
  UpdateFeedPayload,
} from 'src/app/models/feed.model';

// Modelos vivem em src/app/models/feed.model.ts (SSAPP-3) — reexportados
// aqui só pra não quebrar os imports existentes (`from 'src/app/services/feed.service'`)
// em feed.component.ts, edit-widget.component.ts, lives.component.ts e
// slicks-data-view.component.ts. Não redeclarar os tipos aqui.
export type {
  InstagramAccount,
  Feed,
  FeedFilters,
  FeedFilterTree,
  FeedIngest,
  ListFeedsPayload,
  User,
  CreateFeedPayload,
  UpdateFeedPayload,
};
@Injectable({
  providedIn: 'root'
})

export class FeedService {

  constructor(
    private http: HttpClient,
    private sanctum: SanctumService,
    private authHeaderService: AuthHeaderService,
    private revalidatedHttp: RevalidatedHttpService
  ) {
  }

  listFeeds(limit: number = 15, after?: string): Observable<ListFeedsPayload> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds`;

    const params = new HttpParams().set('limit', limit.toString());
    const finalParams = after ? params.set('after', after) : params;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions => {
        const mergedOptions = {
          ...httpOptions,
          params: finalParams
        };
        return this.http.get<ListFeedsPayload>(url, mergedOptions).pipe(
          shareReplay(1)
        );
      })
    );
  }

  // Cache-first com ETag (src/app/core/http-cache).
  listFeedsRevalidated(limit: number = 15, after?: string): RevalidatedResource<ListFeedsPayload> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds`;

    const params = new HttpParams().set('limit', limit.toString());
    const finalParams = after ? params.set('after', after) : params;
    const cacheKey = `feeds:store:${storeId}:${limit}:${after ?? ''}`;

    return this.revalidatedHttp.getSignal<ListFeedsPayload>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions(),
      { params: finalParams }
    );
  }

  updateTikTokAccount(payload: {
    feed_uid: string;
    new_account_id: string;
  }): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/tiktok-account/update`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<any>(url, payload, httpOptions)
          )
        )
      )
    );
  }

  // feed.service.ts

  updateGoogleAccount(payload: { feed_uid: string; new_account_id: string }): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/feed/update-google-account`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<any>(url, payload, httpOptions)
          )
        )
      )
    );
  }

  updateYouTubeChannel(payload: { feed_uid: string; new_account_id: string; channel_id: string }): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/feed/update-youtube-channel`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<any>(url, payload, httpOptions)
          )
        )
      )
    );
  }


  updateInstagramAccount(payload: {
    feed_uid: string;
    new_facebook_user_id: string;
    instagram_user_id: string;
    page_id: string;
  }): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/instagram-account/update`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<any>(url, payload, httpOptions)
          )
        )
      )
    );
  }




  getStorneInfos(subdomain: string): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;
      console.log('chamou 2');
    const url = `${baseUrl}/admin/store`;
    const body = { subdomain };

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, body, httpOptions).pipe(
              retry(1),
              catchError(this.handleError)
            )
          )
        )
      )
    );
  }


  getUser(userId: number): Observable<User> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<User>(url, httpOptions).pipe(
          retry(1),
          catchError((err: any) => {
            console.error('Erro ao buscar usuário', err);
            return of({ id: userId, sub_type: 0 } as User);
          })
        )
      )
    );
  }

  // toggleIngestPublish/toggleIngestPublishInactive (PATCH /ingest/{uid}/publicar|despublicar)
  // removidos — onTogglePublish em feed.component.ts agora usa
  // publicarSelecionados/despublicarSelecionados (POST /asset/pub|despub), que
  // tem a checagem de limite do plano que o endpoint de ingest não tinha.


  onToggleAutoPublish(uid: string): Observable<Feed> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds/${uid}/onToggleAutoPublish`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<Feed>(url, {}, httpOptions) // body vazio
          )
        )
      )
    );
  }




  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Ocorreu um erro do lado do cliente ou da rede.
      console.error('Um erro ocorreu:', error.error.message);
    } else {
      // Ocorreu um erro do lado do servidor.
      console.error(
        `Código do erro ${error.status}, ` +
        `Erro: ${error.error}`);
    }
    // Retornar uma mensagem de erro para o usuário.
    return throwError(
      'Alguma coisa deu errado; tente novamente mais tarde.');
  };

  plans(): Observable<any> {
    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/plans`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>(url, httpOptions).pipe(
          catchError(error => throwError(() => error))
        )
      )
    );
  }

  // Cache-first com ETag (src/app/core/http-cache).
  plansRevalidated(): RevalidatedResource<any> {
    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/plans`;
    const cacheKey = `feed_plans:store:${storeId}`;

    return this.revalidatedHttp.getSignal<any>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


  toggleFeedStatus(uid: string): Observable<Feed> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds/${uid}/onToggleFeedStatusActive`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<Feed>(url, {}, httpOptions) // sem body
          )
        )
      )
    );
  }


  toggleFeedStatusInactive(uid: string): Observable<Feed> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds/${uid}/onToggleFeedStatusInactive`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<Feed>(url, {}, httpOptions) // sem body
          )
        )
      )
    );
  }



  public createFeed(data: CreateFeedPayload): Observable<Feed> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<Feed>(url, data, httpOptions)
          )
        )
      )
    );
  }

  // PATCH /admin/store/{storeId}/feeds/{feed} (FeedsController::update(), SSAPI-13).
  // ⚠️ {feed} aqui é o ID NUMÉRICO do feed (route-model-binding pela PK),
  // não o uid — diferente das rotas de toggle/troca de conta, que usam
  // {uid}. Confirmado direto no backend (routes/api.php), não é um padrão
  // inferido. Use feed.id (vem em toda resposta de GET/POST/listagem).
  public updateFeed(feedId: number, data: UpdateFeedPayload): Observable<Feed> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/feeds/${feedId}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<Feed>(url, data, httpOptions)
          )
        )
      )
    );
  }



  // feed.service.ts
  createAssetsFeed(
    storeId: number,
    feedUid: string,
    payload: any
  ): Observable<{
    success: boolean;
    published_count: number;
    unpublished_count: number;
    assets?: any[];
  }> {
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/feed/${feedUid}/assets`;
    // fi
    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<{
              success: boolean;
              published_count: number;
              unpublished_count: number;
              assets?: any[];
            }>(url, payload, httpOptions)
          )
        )
      )
    );
  }







  deleteFeed(uid: string): Observable<void> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/feeds/${uid}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.delete<void>(url, httpOptions).pipe(
              catchError(error => {
                console.error('Erro ao deletar feed:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  despublicarSelecionados(uids: string[]): Observable<void> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/asset/despub`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<void>(url, { uids }, httpOptions).pipe(
              catchError((error: any) => {
                console.error('Erro ao despublicar itens:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  deleteMultipleAssets(uids: string[]): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/asset/delete-multiple`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post(url, { uids }, httpOptions).pipe(
              catchError(error => {
                console.error('Erro ao deletar múltiplos assets:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }


  publicarSelecionados(uids: string[]): Observable<void> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/asset/pub`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<void>(url, { uids }, httpOptions).pipe(
              catchError((error: any) => {
                console.error('Erro ao publicar itens:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  addTagsToSelected(uids: string[], tags: string[]): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/asset/tags`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post(url, { uids, tags }, httpOptions).pipe(
              catchError(error => {
                console.error('Erro ao adicionar tags em massa:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  // Edição individual das tags de UM slick (LiveShopController::updateAssetTags)
  // — diferente de addTagsToSelected (que só acrescenta em massa), aqui é
  // substituição completa: dá pra remover tag também.
  updateAssetTags(uid: string, tags: string[]): Observable<{ message: string; code?: string; tags?: string; uid?: string }> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/asset/${uid}/tags`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<{ message: string; code?: string; tags?: string; uid?: string }>(url, { tags }, httpOptions).pipe(
              catchError(error => {
                console.error('Erro ao atualizar tags do slick:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  // Associa produtos a vários slicks de uma vez (LiveShopController::addProductsMultiple)
  // — só acrescenta os que ainda não estão associados a cada slick, não duplica.
  addProductsToSelected(uids: string[], products: any[]): Observable<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/asset/products`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post(url, { uids, products }, httpOptions).pipe(
              catchError(error => {
                console.error('Erro ao associar produtos em massa:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  atualizarInsights(uid: string, origem: 'tiktok' | 'instagram'): Observable<{ message: string; insights?: any; handle?: string | null }> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/${origem}/insights`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<{ message: string; insights?: any; handle?: string | null }>(url, { uid }, httpOptions).pipe(
              catchError((error: any) => {
                console.error('Erro ao atualizar insights:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }



  getAccessToken(): string {
    return localStorage.getItem("access_token") || '';
  }
  countSlicks(): Observable<any> {
    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/countslicks`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>(url, httpOptions).pipe(
          catchError(error => throwError(() => error))
        )
      )
    );
  }

  // Cache-first com ETag (src/app/core/http-cache).
  countSlicksRevalidated(): RevalidatedResource<any> {
    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${storeId}/countslicks`;
    const cacheKey = `feed_countslicks:store:${storeId}`;

    return this.revalidatedHttp.getSignal<any>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


}
